import React from 'react';
import ReactDOM from 'react-dom/client';

// Route: /admin → admin portal, everything else → customer portal
const isAdmin = window.location.pathname.startsWith('/admin');

const root = ReactDOM.createRoot(document.getElementById('root'));

if (isAdmin) {
  import('./App').then(({ default: App }) => {
    root.render(<App />);
  });
} else {
  import('./CustomerApp').then(({ default: CustomerApp }) => {
    root.render(<CustomerApp />);
  });
}